<script lang="ts" setup>
import getRandomId from '@/utils/getRandomId.ts';

withDefaults(defineProps<{
  label?: string;
}>(), {
  label: undefined,
});

const inputId = getRandomId('io-');
</script>

<template>
  <div class="io-input-wrapper">
    <label
      v-if="label"
      :for="inputId"
    >
      <slot name="inLabel" :inputId="inputId" /><span v-html="label" />
    </label>
    <slot :inputId="inputId" />
  </div>
</template>

<style lang="scss">
.io-input-wrapper {
  label {
    padding-bottom: .5em;
    font-weight: bold;
  }

  > input, > select, > textarea {
    width: 100%;
    padding: .33333em;
  }
}
</style>
